import { render, staticRenderFns } from "./PayServiceInfo.vue?vue&type=template&id=7933d3ba&scoped=true"
import script from "./PayServiceInfo.vue?vue&type=script&lang=ts"
export * from "./PayServiceInfo.vue?vue&type=script&lang=ts"
import style0 from "./PayServiceInfo.vue?vue&type=style&index=0&id=7933d3ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7933d3ba",
  null
  
)

export default component.exports